export default "__VITE_ASSET__50f813b4__"